// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/admin/styles/adminDashboard.css
 * Design tokens + small custom classes for the Admin / Founder Dashboard.
 * Layout itself is done with Tailwind (matching the rest of the app);
 * this file only holds things Tailwind utility classes can't express cleanly.
 */

:root {
  --admin-primary: #11a8a4;
  --admin-primary-dark: #0d8f8c;
  --admin-primary-light: #e8f8f7;
  --admin-background: #f5f7f8;
  --admin-card: #ffffff;
  --admin-text: #172b2b;
  --admin-muted: #6b7c7c;
  --admin-border: #e2e8e8;
  --admin-success: #10b981;
  --admin-warning: #d97706;
  --admin-danger: #dc2626;
}

.admin-page {
  background-color: var(--admin-background);
  color: var(--admin-text);
}

/* Accordion expand/collapse transition for client & location panels */
.admin-accordion-panel {
  overflow: hidden;
  transition: grid-template-rows 0.2s ease;
  display: grid;
  grid-template-rows: 1fr;
}

.admin-accordion-panel[data-collapsed='true'] {
  grid-template-rows: 0fr;
}

.admin-accordion-panel > div {
  min-height: 0;
}

/* Financial revenue-vs-cost mini comparison bar */
.admin-compare-track {
  position: relative;
  width: 100%;
  height: 8px;
  border-radius: 9999px;
  background-color: var(--admin-border);
  overflow: hidden;
}

.admin-compare-fill {
  position: absolute;
  inset: 0;
  border-radius: 9999px;
  transition: width 0.3s ease;
}

/* Compact table used inside a location group */
.admin-camp-table {
  border-collapse: separate;
  border-spacing: 0;
}

.admin-camp-table th {
  background-color: var(--admin-primary-light);
  color: var(--admin-primary-dark);
}

.admin-camp-table tbody tr:hover {
  background-color: #fafcfc;
}

/* Horizontal scroll shadow cue on mobile tables */
.admin-table-scroll {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

@media (max-width: 640px) {
  .admin-kpi-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Dashboard/Admin_dashboard/adminDashboard.css"],"names":[],"mappings":"AAAA;;;;EAIE;;AAEF;EACE,wBAAwB;EACxB,6BAA6B;EAC7B,8BAA8B;EAC9B,2BAA2B;EAC3B,qBAAqB;EACrB,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;EACE,yCAAyC;EACzC,wBAAwB;AAC1B;;AAEA,sEAAsE;AACtE;EACE,gBAAgB;EAChB,wCAAwC;EACxC,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA,kDAAkD;AAClD;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,qBAAqB;EACrB,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA,+CAA+C;AAC/C;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,4CAA4C;EAC5C,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,kDAAkD;AAClD;EACE,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF","sourcesContent":["/* src/admin/styles/adminDashboard.css\r\n * Design tokens + small custom classes for the Admin / Founder Dashboard.\r\n * Layout itself is done with Tailwind (matching the rest of the app);\r\n * this file only holds things Tailwind utility classes can't express cleanly.\r\n */\r\n\r\n:root {\r\n  --admin-primary: #11a8a4;\r\n  --admin-primary-dark: #0d8f8c;\r\n  --admin-primary-light: #e8f8f7;\r\n  --admin-background: #f5f7f8;\r\n  --admin-card: #ffffff;\r\n  --admin-text: #172b2b;\r\n  --admin-muted: #6b7c7c;\r\n  --admin-border: #e2e8e8;\r\n  --admin-success: #10b981;\r\n  --admin-warning: #d97706;\r\n  --admin-danger: #dc2626;\r\n}\r\n\r\n.admin-page {\r\n  background-color: var(--admin-background);\r\n  color: var(--admin-text);\r\n}\r\n\r\n/* Accordion expand/collapse transition for client & location panels */\r\n.admin-accordion-panel {\r\n  overflow: hidden;\r\n  transition: grid-template-rows 0.2s ease;\r\n  display: grid;\r\n  grid-template-rows: 1fr;\r\n}\r\n\r\n.admin-accordion-panel[data-collapsed='true'] {\r\n  grid-template-rows: 0fr;\r\n}\r\n\r\n.admin-accordion-panel > div {\r\n  min-height: 0;\r\n}\r\n\r\n/* Financial revenue-vs-cost mini comparison bar */\r\n.admin-compare-track {\r\n  position: relative;\r\n  width: 100%;\r\n  height: 8px;\r\n  border-radius: 9999px;\r\n  background-color: var(--admin-border);\r\n  overflow: hidden;\r\n}\r\n\r\n.admin-compare-fill {\r\n  position: absolute;\r\n  inset: 0;\r\n  border-radius: 9999px;\r\n  transition: width 0.3s ease;\r\n}\r\n\r\n/* Compact table used inside a location group */\r\n.admin-camp-table {\r\n  border-collapse: separate;\r\n  border-spacing: 0;\r\n}\r\n\r\n.admin-camp-table th {\r\n  background-color: var(--admin-primary-light);\r\n  color: var(--admin-primary-dark);\r\n}\r\n\r\n.admin-camp-table tbody tr:hover {\r\n  background-color: #fafcfc;\r\n}\r\n\r\n/* Horizontal scroll shadow cue on mobile tables */\r\n.admin-table-scroll {\r\n  overflow-x: auto;\r\n  -webkit-overflow-scrolling: touch;\r\n}\r\n\r\n@media (max-width: 640px) {\r\n  .admin-kpi-grid {\r\n    grid-template-columns: repeat(2, minmax(0, 1fr));\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
